export default "__VITE_ASSET__Nj0ALEo1__"